var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.07 1.72C.07.77.86 0 1.833 0h20.324c.973 0 1.762.77 1.762 1.72v20.56c0 .95-.789 1.72-1.762 1.72H1.833C.859 24 .07 23.23.07 22.28V1.72ZM7.3 20.09V9.253H3.696V20.09H7.3ZM5.497 7.773c1.256 0 2.038-.832 2.038-1.872-.023-1.063-.781-1.872-2.014-1.872-1.232 0-2.038.809-2.038 1.872 0 1.04.782 1.872 1.99 1.872h.024Zm7.397 12.317H9.293s.047-9.82 0-10.837h3.602v1.534a3.325 3.325 0 0 0-.024.038h.024v-.038C13.374 10.05 14.231 9 16.141 9c2.37 0 4.147 1.549 4.147 4.877v6.214h-3.601v-5.797c0-1.457-.522-2.451-1.825-2.451-.995 0-1.588.67-1.848 1.317-.095.232-.119.555-.119.88v6.051Z",
    fill: "currentColor"
  })));
};
export default SvgLinkedin;